module.exports = __webpack_public_path__ + "static/usage_regist_master-83458cd1ab7c65b23e4192be7335be0c.jpg";